module.exports = __webpack_public_path__ + "static/undraw_Reviewed_docs_re_9lmr-aefa1c5314ac35eccb12f5068f6802bb.svg";